import orderBy from "lodash/orderBy";
import { NavSidebarToggleState } from "@teaming/common-enums";
import { upcat } from "@teaming/common-util";
import { getRelativeOneOnOneMembers } from "@teaming/common-ui/utils/teamUtil";
import hostLayoutEventListenersFactory from "./hostLayoutEventListeners";
import { foundation, appChannels } from "@teaming/slice-engine";

export default function hostLayoutStoreFactory() {
	const { store, auth, } = foundation();
	const { ioChannel, } = appChannels;

	hostLayoutEventListenersFactory( { auth, store, ioChannel, } );

	const pristineState = () => {
		return {
			currentUserId: "",
			toggleState: NavSidebarToggleState.UNTOGGLED,
			myFavoriteTeams: [],
			myFavoriteOneOnOnes: [],
		};
	};

	return store.registerModule( "host-layout", {
		namespaced: true,
		state: pristineState(),
		getters: {
			toggleState: state => state.toggleState,
			myFavoriteTeams( state ) {
				return orderBy(
					state.myFavoriteTeams,
					[ "name", ],
					[ "asc", ]
				);
			},
			myFavoriteOneOnOnes( state ) {
				if ( !state.currentUserId ) {
					return [];
				}
				const renamedOneOnOnes = state.myFavoriteOneOnOnes.map( oneOnOne => {
					const {
						otherMember,
					} = getRelativeOneOnOneMembers( oneOnOne, state.currentUserId );
					const name = otherMember.displayName;
					return {
						id: oneOnOne.id,
						name,
						orderKey: name.toLowerCase(),
					};
				} );

				return orderBy(
					renamedOneOnOnes,
					[ "orderKey", ],
					[ "asc", ]
				);
			},
		},
		mutations: {
			toggleNavSidebar( state, toggleState ) {
				if ( NavSidebarToggleState.includes( toggleState ) ) {
					state.toggleState = toggleState;
				}
			},
			openNavSidebar( state ) {
				state.toggleState = NavSidebarToggleState.OPEN;
			},
			closeNavSidebar( state ) {
				if ( [ NavSidebarToggleState.UNTOGGLED, NavSidebarToggleState.CLOSED, ].includes( state.toggleState ) ) {
					return;
				}
				state.toggleState = NavSidebarToggleState.CLOSED;
			},
			receiveUserProfile( state, { userProfile, } ) {
				state.currentUserId = userProfile?.personId;
			},
			receiveFavoriteTeams( state, { favoriteTeams, } ) {
				state.myFavoriteTeams = upcat(
					state.myFavoriteTeams,
					favoriteTeams,
					upcat.idComparator
				);
			},
			receiveFavoriteOneOnOnes( state, { favoriteOneOnOnes, } ) {
				state.myFavoriteOneOnOnes = upcat(
					state.myFavoriteOneOnOnes,
					favoriteOneOnOnes,
					upcat.idComparator
				);
			},
			receiveUnfavoriteTeam( state, { teamId, } ) {
				state.myFavoriteTeams = state.myFavoriteTeams.filter(
					t => t.id !== teamId
				);
			},
			receiveUnfavoriteOneOnOne( state, { oneOnOneId, } ) {
				state.myFavoriteOneOnOnes = state.myFavoriteOneOnOnes.filter(
					o => o.id !== oneOnOneId
				);
			},
			removeTeam( state, { teamId, } ) {
				state.myFavoriteTeams = state.myFavoriteTeams.filter( team => team.id !== teamId );
			},
		},
		actions: {},
	} );
}
